import { Skeleton } from "@material-ui/lab";
import { useStyles } from "./styles";

interface Props {
  items: number;
}

export default function ListItemSkeleton(props: Props) {
  const classes = useStyles();

  return (
    <>
      {Array.from(Array(props.items).keys()).map(i => (
        <div key={i} className={classes.skeletonRow}>
          <div className={classes.skeletonInfo}>
            <Skeleton variant="text" animation="wave" width="60%" height={20} />
            <div className={classes.skeletonChips}>
              <Skeleton
                variant="rect"
                animation="wave"
                width={36}
                height={20}
                style={{ borderRadius: 10 }}
              />
              <Skeleton
                variant="rect"
                animation="wave"
                width={36}
                height={20}
                style={{ borderRadius: 10 }}
              />
            </div>
          </div>
          <div className={classes.skeletonActions}>
            <Skeleton
              variant="circle"
              animation="wave"
              width={28}
              height={28}
            />
            <Skeleton
              variant="circle"
              animation="wave"
              width={28}
              height={28}
            />
          </div>
        </div>
      ))}
    </>
  );
}
